import { render, staticRenderFns } from "./my-radio.vue?vue&type=template&id=20edf37a&scoped=true&"
import script from "./my-radio.vue?vue&type=script&lang=js&"
export * from "./my-radio.vue?vue&type=script&lang=js&"
import style0 from "./my-radio.vue?vue&type=style&index=0&id=20edf37a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20edf37a",
  null
  
)

export default component.exports